import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { NavigationExtras, Router, RouterOutlet } from '@angular/router';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { ExcelExportEvent, KENDO_GRID, KENDO_GRID_EXCEL_EXPORT } from '@progress/kendo-angular-grid';
import { KENDO_SVGICON } from '@progress/kendo-angular-icons';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { KENDO_BREADCRUMB } from '@progress/kendo-angular-navigation';
import { cloudIcon, fileExcelIcon } from '@progress/kendo-svg-icons';
import { ProjectsI } from '../../_models/projects';
import { ProjectsService } from '../../_services/projects.service';
import { FlatBindingDirective } from '@progress/kendo-angular-treelist';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { formatDate } from '../../globals';
import { SubjectService } from '../../_services/subject.service';
import { combineLatest, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators'

@Component({
    selector: 'app-projects',
    imports: [KENDO_SVGICON, KENDO_BUTTON, KENDO_GRID, KENDO_BREADCRUMB, KENDO_GRID_EXCEL_EXPORT, InputsModule,
        LayoutModule, CommonModule],
    templateUrl: './projects.component.html',
    styleUrl: './projects.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class ProjectsComponent implements OnInit, OnDestroy {
  projects: ProjectsI[] = [];
  selection: any[] = [];
  width = '300';
  svgIcon = [cloudIcon, fileExcelIcon];
  copyProjects: ProjectsI[] = [];
  loading = false;
  displayOrderNoAcceess = false;
  @Input() url: any;
  private destroy$ = new Subject<void>();
  @ViewChild(FlatBindingDirective) dataBinding!: FlatBindingDirective;
  constructor(private service: ProjectsService, private cdr: ChangeDetectorRef,
    private router: Router, private sub: SubjectService) {
    this.getProjectsList();
  }

  getProjectsList() {
    this.loading = true;
    this.service.getProjects().subscribe({
      next: (result) => {
        this.projects = result;
        this.copyProjects = this.projects;
        this.loading = false;
        this.cdr.markForCheck();
      },
      error: (error) => {
        //throw message of some sort
        console.log(error)
      },
      complete: () => {
        for (var i = 0; i < this.projects.length; i++) {
          if (this.projects[i].maxuploaddate != null) {
            this.projects[i].maxuploaddate = this.convertDate(this.projects[i].maxuploaddate)
            //this.projects[i].maxuploaddate = new Date(this.projects[i].maxuploaddate);

          }
          if (this.projects[i].hasProcessRole) {
            this.displayOrderNoAcceess = true;
          }
        }
      }

    });

    // this.service.getProjects().subscribe(res => {
    //   this.projects = res;
    //   this.copyProjects = this.projects;
    //   this.cdr.markForCheck();
    // })
  }
  ngOnInit(): void {
    this.sub.refreshTrigger$
      .pipe(
        takeUntil(this.destroy$),
        filter(trigger => trigger === 'projects')
      )
      .subscribe(() => {
        this.getProjectsList();
        this.cdr.markForCheck();
      });
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  public rowCallback = (context: any) => {
    console.log(context.dataItem.totalpocount, 'total po count');
    return {
      'hide-row': context.dataItem.totalpocount == 0
    };
  };
  public onFilter(value: string): void {
    const scalingFactor = 7; // This value depends on the font size and family
    const characterCount = value.length;
    const newWidth = Math.max(50, characterCount * scalingFactor);
    if (+this.width < 400) {
      if (newWidth - 100 > 0 && newWidth - 100 < 500) {
        this.width = (newWidth + 200).toString();
      }
    }
    if (value.length) {
      this.projects = this.copyProjects.filter(obj => obj.projectname.toLocaleLowerCase().includes(value.toLowerCase()));
    } else {
      this.projects = this.copyProjects;
      this.width = '300';
    }
  }
  navigate(str: string, count: number, dataItem?: any) {
    // if (count > 0) {
    if (str == 'upload') {
      sessionStorage.setItem('selected', JSON.stringify(false));
      this.router.navigate(['portal']);
    } else {
      const navigationExtras: NavigationExtras = {
        state: {
          url: `${dataItem.projectId}/${dataItem.projectname}`
        }
      };
      this.router.navigate(['/orders'], navigationExtras);
    }
    // }
  }
  getCount(totalpocount: number, pocount: number) {
    return totalpocount > 0 ? `${pocount} (${totalpocount})` : pocount
  }
  getAllCount(totaluploadcount: number, filecount: number) {
    return filecount > 0 ? `${totaluploadcount} & ${filecount}` : totaluploadcount
  }

  getNoAccessColumnData(project: ProjectsI) {
    return project.hasProcessRole ? project.totalpocount : '';
  }

  convertDate(value: Date): Date {
    const dateValue = new Date(value);

    const timezoneOffset = dateValue.getTimezoneOffset(); // Offset in minutes

    const localDate = new Date(dateValue.getTime() + timezoneOffset * 60 * 1000);

    return localDate;
  }
  getFileName() {
    let str = 'Projects Overview';
    return `${str} ${this.getFormattedDate()}.xlsx`
  }
  getFormattedDate(): string {
    const date = new Date();
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  onExcelExport(e: ExcelExportEvent): void {
    const sheet = e.workbook.sheets[0];
    const header = sheet.rows[0];
    const getIndex = (field: string) => header.cells.findIndex((c: any) => c?.value === field);

    //const orderIndex = getIndex('Orders');
    //const uploadCount = getIndex('All Submittals & Files');
    const dateCount = getIndex('Last Submittal Date');
    let orderNoAccessIndex = -1;
    if (this.displayOrderNoAcceess) {
      orderNoAccessIndex = getIndex('Orders(No Access)');
    }

    this.projects.forEach((item, i) => {
      const row = sheet.rows[i + 1];
      if (!row || row.type !== 'data') return;

      row.cells[orderNoAccessIndex].value = this.displayOrderNoAcceess && orderNoAccessIndex > -1 && item.hasProcessRole
        ? item.totalpocount : '';
      row.cells[dateCount].value = item.maxuploaddate ? formatDate(item.maxuploaddate) : null;
    });
  }

}
